<template>
  <div id="app" v-cloak>
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import vue from 'vue'

export default {
  name: 'App',
  provide() {//父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  watch: {
    '$route'(to, from) {
      vue.ls.set('activeIndex', this.$route.name);
    },
  },
  data() {
    return {
      isRouterAlive: true //控制视图是否显示的变量
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;  //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true;  //再打开
      })
    }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

[v-cloak] {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue